// import HeaderImage from "../../components/header-image/header-image";
// import VacantePrimaPagina from "../vacante/vacante-prima-pagina";
// import CarouselHomePageCorporate from "../../components/carousel/carousel-corporate-home-page";
// import CarouselHomePageLeisure from "../../components/carousel/carousel-leisure-home-page";
// import BlogPrimaPagina from "../blog/blog-prima-pagina";
import CookieContent from "../../components/cookie-content/cookie-content";
// import Rezerva from "../../components/rezerva/rezerva";
import GridPromoAfPremiumFEB26 from "../../components/grid-promo/grid-promo-feb-2026-af-premium.jsx";
import GridPromoAfBusinessFEB26 from "../../components/grid-promo/grid-promo-feb-2026-af-business.jsx";
import GridPromoKLPremiumFEB26 from "../../components/grid-promo/grid-promo-feb-2026-kl-premium.jsx";
import GridPromoKLBusinessFEB26 from "../../components/grid-promo/grid-promo-feb-2026-kl-business.jsx";

import GridPromoAfMAR from "../../components/grid-promo/grid-promo-mar-2026-AF.jsx";
import GridPromoKlMAR from "../../components/grid-promo/grid-promo-mar-2026-KL.jsx";

import HeaderNew from "../../components/components-new-home/headerNew/header";
import HomeTextSection from "../../components/components-new-home/headerNew/headerTextAbout";
import StatBox from "../../components/components-new-home/headerNew/stats";
import CertificationsSection from "../../components/components-new-home/headerNew/certification";
import MissionVisionValues from "../../components/components-new-home/headerNew/missionvisionvalues";
import TeamMember from "../../components/components-new-home/headerNew/team";

// import PremiumPromo from "../../components/grid-promo/grid-promo-2025-klm";
import ServicesSummary from "../../components/components-new-servicii/servicesHomeRez";

const Home = () => {
  // const HeaderImg1 =
  //   "url('https://images.unsplash.com/photo-1520437358207-323b43b50729?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80')";

  return (
    <>
      {/* Header new */}

      {/* <GridPromoAfMAR />
      <GridPromoKlMAR /> */}

      <GridPromoAfPremiumFEB26 />
      <GridPromoAfBusinessFEB26 />
      <GridPromoKLPremiumFEB26 />
      <GridPromoKLBusinessFEB26 />

      {/* <PremiumPromo /> */}
      {/* <TurkishAirlinesPromo /> */}
      <HeaderNew />
      <HomeTextSection />
      <StatBox />
      <ServicesSummary />
      <MissionVisionValues />
      <CertificationsSection />
      <TeamMember />
      {/* Header New */}
      {/* <CarouselHomePageCorporate />
      <GridPromo /> */}
      {/* <CarouselHomePageLeisure />
      <VacantePrimaPagina /> */}
      {/* <GridPromoAfNov />
      <GridPromoKlNov />
      <BlogPrimaPagina />
      <HeaderImage HeaderImg={HeaderImg1} /> */}
      <CookieContent />
    </>
  );
};

export default Home;
